
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoahmednagarcabs() {



    const cardData =
    {
        keyword: ' Pune to Ahmednagar Cab',
        heading: 'Prince Cabs: Pune to Ahmednagar Cab',
        headingDescription: 'Prince Cabs provides reliable Pune to Ahmednagar Cab services, ideal for business trips, family travel, religious tours, and weekend journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride along the Pune–Ahmednagar route. With professional chauffeurs, flexible timings, and on-time pickups, we make your travel smooth and hassle-free. Whether it’s for Shirdi Darshan, exploring historical forts, or official visits, choose Prince Cabs’ trusted cab service from Pune to Ahmednagar for convenience, comfort, and affordability.',

        top: 'Top Places to Visit in Ahmednagar with Prince Cabs',

"topPlaces": [
  {
    "title": "Ahmednagar Fort",
    "description": "The Ahmednagar Fort, built in 1490 by Ahmad Nizam Shah, is one of the strongest forts in India. Surrounded by thick stone walls and deep moats, it has witnessed many historic battles. The fort was later used by the British as a prison, where Pandit Jawaharlal Nehru wrote his famous ‘Discovery of India.’ Its massive bastions, gateways, and circular design attract history lovers. The fort stands as a symbol of Ahmednagar’s rich past and resilience. It is a must-visit for heritage and history enthusiasts."
  },
  {
    "title": "Meherabad",
    "description": "Meherabad is a spiritual site located near Ahmednagar, dedicated to Meher Baba, a spiritual master revered worldwide. The site houses his tomb, known as the Samadhi, which attracts pilgrims from across the globe. The serene environment offers meditation spaces and libraries about his teachings. Each year, Amartithi (the anniversary of Meher Baba’s passing) draws thousands of followers. Meherabad beautifully blends spirituality and peace. It is a major destination for seekers of inner harmony."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located about 35 km from Ahmednagar, Shani Shingnapur is one of India’s most unique pilgrimage sites. Dedicated to Lord Shani, the deity of justice, the temple features a black stone idol installed in the open, without a roof. The village is also famous for its tradition of houses without doors, as residents believe Lord Shani protects them. Saturdays see large gatherings of devotees offering oil to the deity. The temple’s unusual traditions make it a place of immense curiosity and devotion."
  },
  {
    "title": "Salabat Khan’s Tomb (Chand Bibi Mahal)",
    "description": "Perched on a hill, Salabat Khan’s Tomb, popularly known as Chand Bibi Mahal, is a striking 17th-century monument. Built in stone, the three-storeyed octagonal structure offers panoramic views of Ahmednagar city. Despite being a tomb, locals often associate it with the legendary queen Chand Bibi. The site’s blend of history, architecture, and scenic location makes it a popular tourist attraction. It is particularly beautiful during sunrise and sunset. Visitors enjoy both the heritage and the natural surroundings."
  },
  {
    "title": "Tank Museum",
    "description": "The Cavalry Tank Museum in Ahmednagar is Asia’s only museum dedicated to tanks and armored vehicles. Established in 1994, it houses over 50 exhibits, including tanks used during World Wars and India’s wars with Pakistan. The star attraction is the famous Vijayanta and Centurion tanks. The museum educates visitors about India’s military history and technological evolution. It is a must-visit for defense enthusiasts and families. The outdoor displays make it an exciting and educational experience."
  },
  {
    "title": "Rehekuri Blackbuck Sanctuary",
    "description": "Rehekuri Blackbuck Sanctuary, located near Karjat in Ahmednagar district, is a protected area dedicated to the elegant Indian blackbuck. Spread over 2 sq. km, it shelters more than 400 blackbucks, along with chinkaras, wolves, and birds. The sanctuary is a paradise for wildlife photographers and nature lovers. Open grasslands make it easy to spot herds grazing peacefully. Eco-tourism facilities have been developed to promote conservation. It is an ideal spot for a day trip from Ahmednagar."
  },
  {
    "title": "Ralegan Siddhi",
    "description": "Ralegan Siddhi is a model village located in Ahmednagar district, made famous by social activist Anna Hazare. Once drought-prone, the village transformed into a sustainable community through watershed management and collective effort. Visitors come to study its rural development model and eco-friendly practices. The village showcases solar energy, biogas plants, and water conservation methods. It is an inspiring example of social reform and environmental sustainability. Ralegan Siddhi is a must-see for students and reformers."
  },
  {
    "title": "Alamgir Dargah",
    "description": "The Alamgir Dargah, located on the outskirts of Ahmednagar, is dedicated to the Sufi saint Sultan Baba. The dargah is revered by people of all faiths, symbolizing unity and brotherhood. Its peaceful surroundings and annual Urs festival draw large crowds of devotees. The white dome and simple architecture exude serenity. Visitors often come here for blessings and to experience the spiritual ambiance. It is one of the city’s most respected religious sites."
  },
  {
    "title": "Harishchandragad Fort",
    "description": "Though located on the Ahmednagar–Pune border, Harishchandragad Fort is a major trekking destination for adventure seekers. The fort is famous for Konkan Kada, a cliff offering breathtaking views of the Sahyadris. Ancient temples like Kedareshwar Cave Temple and the Saptatirtha Pushkarni add spiritual significance. Trekkers enjoy exploring its rugged terrain and caves. Monsoon enhances its charm with mist and waterfalls. It is a thrilling combination of history, adventure, and nature."
  },
  {
    "title": "Mula Dam",
    "description": "Mula Dam, built on the Mula River near Rahuri in Ahmednagar, is one of the largest dams in Maharashtra. The vast reservoir is surrounded by green hills, creating a scenic picnic spot. Visitors enjoy boating, fishing, and nature walks here. The dam also plays a key role in irrigation and water supply for the region. During monsoon, the water level rises, making it particularly picturesque. It is a refreshing retreat for families and nature lovers."
  }
],


"services": [
    {
        "name": "Pune to Ahmednagar Taxi Fare",
        "description": "Check the most competitive and transparent taxi fares for your journey from Pune to Ahmednagar. We offer fixed-rate packages with no hidden costs, ensuring clarity and convenience. Our pricing includes driver allowance, tolls, and taxes, giving you a worry-free and budget-friendly travel experience."
    },
    {
        "name": "Pune to Ahmednagar Cab Service",
        "description": "Book our reliable and professional cab service from Pune to Ahmednagar for a smooth and comfortable journey. Whether it's for business travel, family visits, or local tourism, we provide clean, well-maintained vehicles and trained drivers who ensure on-time pickups and safe travel throughout the route."
    },
    {
        "name": "Pune to Ahmednagar Cab Rates",
        "description": "Get affordable and flexible cab rate options for your Pune to Ahmednagar travel. Choose from sedans, SUVs, and premium cars based on your budget and group size. Our cab rates are designed to suit both one-way and round-trip travel plans, with the option to include waiting time or return journeys."
    },
    {
        "name": "Ahmednagar to Pune Cab",
        "description": "Need a return cab from Ahmednagar to Pune? We offer easy and reliable cab booking for your return journey with the same professional standards. Enjoy door-to-door service, courteous drivers, and clean, comfortable cars that make the return trip just as relaxing and safe."
    },
    {
        "name": "Pune to Ahmednagar Innova Cab",
        "description": "Travel from Pune to Ahmednagar in a spacious and comfortable Innova cab, ideal for families and groups. The vehicle comes with air conditioning, ample luggage space, and plush seating for long-distance comfort. Our drivers ensure a smooth ride, making your journey pleasant and efficient."
    },
    {
        "name": "Pune to Ahmednagar Dzire Taxi",
        "description": "Opt for our Swift Dzire taxi for a cost-effective and comfortable ride from Pune to Ahmednagar. This sedan is perfect for small families or solo travelers seeking an air-conditioned, reliable, and safe travel option without stretching the budget."
    },
    {
        "name": "Pune to Ahmednagar Etios Cab",
        "description": "Book our Toyota Etios cab for a smooth, economical journey from Pune to Ahmednagar. The Etios offers a spacious interior and excellent ride quality, ideal for couples, business travelers, or small groups looking for comfort at a reasonable fare."
    },
    {
        "name": "Pune to Ahmednagar Affordable Taxi",
        "description": "Looking for budget-friendly travel to Ahmednagar from Pune? Our affordable taxi options provide safe, clean, and well-maintained vehicles at the best rates. With experienced drivers and flexible booking options, we make economical travel convenient and comfortable."
    },
    {
        "name": "Pune to Ahmednagar Round Trip Cab",
        "description": "Plan your round trip from Pune to Ahmednagar with our dedicated cab service that gives you full flexibility and comfort. Our drivers remain available throughout your trip, making it easy to attend events or meetings and return home without stress or delays."
    },
    {
        "name": "Pune to Ahmednagar Family Cab",
        "description": "Choose our family cab service for a safe and comfortable ride from Pune to Ahmednagar. With spacious seating, child-friendly features, and courteous drivers, we make your family trip enjoyable and relaxing. Ideal for weekend outings, family functions, or vacation travel."
    }
],
"tableData": [
    ["Pune to Ahmednagar Taxi Fare", "Pune to Ahmednagar Cab Service"],
    ["Pune to Ahmednagar Cab Rates", "Ahmednagar to Pune Cab"],
    ["Pune to Ahmednagar Innova Cab", "Pune to Ahmednagar Dzire Taxi"],
    ["Pune to Ahmednagar Etios Cab", "Pune to Ahmednagar Affordable Taxi"],
    ["Pune to Ahmednagar Round Trip Cab", "Pune to Ahmednagar Family Cab"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Ahmednagar Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and timely cab services from Pune to Ahmednagar, ideal for business travel, family visits, historical site tours, or official work. Whether you're heading to visit the Ahmednagar Fort, Shirdi nearby, or attending a meeting, we ensure that your travel experience is smooth, punctual, and professional from start to finish."
    },
    {
        "WhyChooseheading": "Comfortable, Well-Maintained Vehicles for a Relaxing Ride",
        "WhyChoosedescription": "Our fleet of vehicles includes air-conditioned hatchbacks, sedans, and SUVs equipped with clean, spacious, and ergonomic interiors. Whether you're traveling alone, with family, or in a group, you'll enjoy a relaxing ride on the ~120 km journey, with enough space for luggage and a peaceful cabin environment for long drives."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our drivers are trained professionals familiar with the Pune–Ahmednagar highway and alternate routes to avoid traffic congestion. They ensure safe and smooth driving throughout the trip, are polite and punctual, and are well-versed in making the necessary pit stops for food or refreshments based on your preferences."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Match Your Schedule",
        "WhyChoosedescription": "Whether you’re booking a one-way drop, round-trip, or need a cab for multiple stops or extended hours, Prince Cabs offers fully customizable travel plans. Early morning departures, late-night returns, or quick turnarounds—we adjust to your travel requirements. Book easily via website, WhatsApp, or a quick call and get instant confirmation."
    },
    {
        "WhyChooseheading": "High Hygiene Standards and Safety-First Approach",
        "WhyChoosedescription": "We maintain strict hygiene standards for every vehicle. All cabs are deep-cleaned and sanitized before each trip. Our vehicles also go through regular mechanical checks and are equipped with safety features like GPS tracking, airbags, seat belts, and first-aid kits to ensure a secure ride for every passenger."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Surprise Costs",
        "WhyChoosedescription": "Prince Cabs offers upfront and competitive pricing for Pune to Ahmednagar travel. You’ll receive a clear quote before the trip begins, and we never charge hidden fees. Pay the way you prefer—using UPI, debit/credit card, net banking, or cash—for a smooth, trustworthy payment experience."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Peace of Mind",
        "WhyChoosedescription": "Our dedicated customer support team is available at all hours to help with bookings, route assistance, or in-transit changes. Whether you need to delay your trip, update a stop, or get live driver updates, we’re here to ensure your Pune to Ahmednagar cab journey is worry-free, convenient, and completely reliable."
    }
]



























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Ahmednagar cab services?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab services from Pune to Ahmednagar, suitable for business travel, family visits, and sightseeing.',
    },
    {
        question: 'What types of vehicles are available for Pune to Ahmednagar trips?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to accommodate solo travelers and groups of all sizes.',
    },
    {
        question: 'Are your cabs suitable for long-distance travel like Pune to Ahmednagar?',
        answer: 'Absolutely! Our vehicles are air-conditioned, well-maintained, and driven by experienced drivers to ensure a safe and comfortable journey.',
    },
    {
        question: 'Can I customize my itinerary for the Pune to Ahmednagar route?',
        answer: 'Yes, you can customize pickup points, drop locations, and request stopovers at popular spots along the way.',
    },
    {
        question: 'What are the charges for a Pune to Ahmednagar cab?',
        answer: 'Cab charges depend on vehicle type, travel duration, and any additional requirements. Contact Prince Cabs for a customized and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Ahmednagar cab with Prince Cabs?',
        answer: 'Booking is easy—simply call us or visit our website with your travel details, and our team will assist you in selecting the best cab.',
    },
    {
        question: 'Are the cabs cleaned and maintained for intercity travel?',
        answer: 'Yes, all our vehicles are regularly sanitized, serviced, and maintained to provide a safe and comfortable ride to Ahmednagar.',
    },
];

const testimonials = [
    {
        name: "Mr. Prakash More",
        position: "Frequent Traveler",
        text: "I regularly use Prince Cabs for my Pune to Ahmednagar trips. The service is reliable and the cars are always in excellent condition.",
        image: "/img/testimonial/testimonial-thumb-ahmednagar-1.png",
    },
    {
        name: "Mrs. Sneha Patil",
        position: "Family Traveler",
        text: "Our trip from Pune to Ahmednagar was very comfortable thanks to Prince Cabs. The driver was punctual and courteous.",
        image: "/img/testimonial/testimonial-thumb-ahmednagar-2.png",
    },
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ahmednagar Cab",
  "image": "https://princecab.com/assets/images/pune-ahmednagar-cab.jpg",
  "description": "Book Pune to Ahmednagar cab with Prince Cabs offering reliable and affordable taxi services including Innova, Dzire, and Etios. Ideal for one-way and round trips, family travel, and quick bookings. 24/7 online service available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "6800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-ahmednagar-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Ahmednagar Cab | Affordable & Reliable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Ahmednagar cab service with Innova, Dzire, and Etios taxis. Affordable fares for round trips, family travel, and one-way rides. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Ahmednagar Taxi Fare, Pune to Ahmednagar Cab Service, Pune to Ahmednagar Cab Rates, Ahmednagar to Pune Cab, Pune to Ahmednagar Innova Cab, Pune to Ahmednagar Dzire Taxi, Pune to Ahmednagar Etios Cab, Pune to Ahmednagar Affordable Taxi, Pune to Ahmednagar Round Trip Cab, Pune to Ahmednagar Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoahmednagarcabs;